import i18n from "@/lib/i18n/i18n"

const RECONNECTING_TOAST_DEBOUNCE = 1000

let toastTimeoutId: NodeJS.Timeout | null = null
let reconnectingToastShown = false

export default class ReconnectStatusReactor {
  static handleReconnectStatusChange(status: string) {
    if (toastTimeoutId) {
      clearTimeout(toastTimeoutId)
    }

    if (status === "reconnecting") {
      ReconnectStatusReactor.handleReconnecting()
    }

    if (status === "reconnected") {
      ReconnectStatusReactor.handleReconnected()
    }
  }

  static handleReconnecting() {
    toastTimeoutId = setTimeout(() => {
      reconnectingToastShown = true
      window.appToaster.show(
        {
          message: i18n.t("app.connection.reconnecting"),
          intent: "danger",
          timeout: 0,
        },
        "connection",
      )
    }, RECONNECTING_TOAST_DEBOUNCE)
  }

  static handleReconnected() {
    if (reconnectingToastShown) {
      window.appToaster.show(
        {
          message: i18n.t("app.connection.backOnline"),
          intent: "success",
          timeout: 3000,
        },
        "connection",
      )

      reconnectingToastShown = false
    }
  }
}
